import logo from './logo.svg';
import './App.css';
import ContentHolder from './MyComponents/ContentHolder';

function App() {
  return (
    <>
      <ContentHolder/>
    </>
  );
}

export default App;
